"use strict";


const baseURL = "https://medical-ruby.pixoatic.com";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.baseURL = baseURL; 